import { render, staticRenderFns } from "./MatchDetailsInformation.vue?vue&type=template&id=438b3303&scoped=true"
import script from "./MatchDetailsInformation.vue?vue&type=script&lang=js"
export * from "./MatchDetailsInformation.vue?vue&type=script&lang=js"
import style0 from "./MatchDetailsInformation.vue?vue&type=style&index=0&id=438b3303&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438b3303",
  null
  
)

export default component.exports